module.exports = __webpack_public_path__ + "img/neo-burger.264995a6.svg";